module.exports = __webpack_public_path__ + "static/media/betsInCurrentRoom_3.405756b3.mp3";